export default {
    TITLE:'Will the company have shares in any companies not yet formed?',
    SUBTITLE:'Assets and revenue',
    TOOLTIP:'Big plans? Choose \'Yes, it will’ if the company you’re forming is going to be a corporate shareholder in another company which has not yet been incorporated.'
}